import { initContract } from "@ts-rest/core";
import { QuickbuyAPI } from "../../interfaces/quickbuy/api";
import { ApiMetaSchemas } from "../utils";
import { z } from "zod";

const contractInstance = initContract();

export const quickbuyContract = contractInstance.router(
  {
    products: {
      getProducts: {
        method: "GET",
        path: "/products",
        responses: {
          200: ApiMetaSchemas.countSchema(QuickbuyAPI.Product.schema),
        },
        query: ApiMetaSchemas.pageQuerySchema(10).extend({
          productName: z.string().optional(),
        }),
      },
    },
  },
  {
    pathPrefix: "/quick-buy",
  }
);
